"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgThumbsUp = function SvgThumbsUp(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M27 20h4.649a3 3 0 013 3.452l-1.38 8.998A2.997 2.997 0 0130.28 35H19a1 1 0 01-1-1V23a1 1 0 01.086-.406l4-9A1 1 0 0123 13a4 4 0 014 4v3zm-7 13h10.291a1 1 0 001-.852l1.38-8.998A1 1 0 0031.66 22H26a1 1 0 01-1-1v-4a2 2 0 00-1.392-1.906L20 23.212V33zm-2 0v-9h-2a1 1 0 00-1 1v7a1 1 0 001 1h2zm1 2h-3a3 3 0 01-3-3v-7a3 3 0 013-3h3a1 1 0 011 1v11a1 1 0 01-1 1z",
    id: "thumbs-up_svg__a"
  }));
};

var _default = SvgThumbsUp;
exports["default"] = _default;